import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import moment from 'moment-timezone';

import Routes from './Routes';
import Loading from 'components/LoadingOverlay';

import generic from 'locales';

import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/si';

import 'components/Localization/LocalizationAssistant.css';
import {
  LocalizationAssistant_Parse,
  LocalizationAssistant_MutationObserver_Callback,
} from 'components/Localization/LocalizationAssistant.js';

const defineLocale = (locale) => {
  if (!!generic.locales[locale] && !!generic.locales[locale].moment) {
    moment.defineLocale(locale, generic.locales[locale].moment);
  } else {
    moment.locale(locale);
  }
};

@inject('app', 'user')
@observer
class App extends Component {
  async componentWillMount() {
    switch (process.env.REACT_APP_TENANT) {
      case 'amarc21':
        moment.updateLocale('en', generic.locales.en.moment);
        moment.defineLocale('de', generic.locales.de.moment);
        break;
      case 'remax-at':
        moment.defineLocale('de', generic.locales.de.moment);
        moment.updateLocale('en', generic.locales.en.moment);
        break;
      case 'remax-it':
        moment.updateLocale('en', generic.locales.en.moment);
        moment.defineLocale('de', generic.locales.de.moment);
        moment.defineLocale('fr', generic.locales.fr.moment);
        moment.defineLocale('it', generic.locales.it.moment);
        break;
      case 'remax-de':
        moment.updateLocale('en', generic.locales.en.moment);
        moment.defineLocale('de', generic.locales.de.moment);
        break;
      case 'remax-ro':
        moment.updateLocale('en', generic.locales.en.moment);
        moment.defineLocale('ro', generic.locales.ro.moment);
        break;
      default:
        moment.defineLocale('de', generic.locales.de.moment);
        defineLocale('fi');
        defineLocale('en-ZA');
        // defineLocale('es');
        moment.defineLocale('es', generic.locales.es.moment);
        moment.defineLocale('sl', generic.locales.sl.moment);
        moment.defineLocale('sl-SI', generic.locales.sl.moment);
        break;
    }

    const app = this.props.app;
    if (!app.ready) {
      app.init();
    }
  }

  observer;

  async componentDidMount() {
    if (
      process.env.REACT_APP_LOCALIZATION_ASSISTANT === true ||
      process.env.REACT_APP_LOCALIZATION_ASSISTANT === 'true'
    ) {
      window.LocalizationAssistant_Url =
        process.env.REACT_APP_LOCALIZATION_ASSISTANT_URL;
      setTimeout(function () {
        LocalizationAssistant_Parse(document.body);
        this.observer = new MutationObserver(
          LocalizationAssistant_MutationObserver_Callback
        );
        this.observer.observe(document.body, {
          childList: true,
          attributes: true,
          subtree: true,
        });
      }, 100);
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  render() {
    const { app } = this.props;

    return !app.ready ? (
      <Loading fullscreen={true} />
    ) : (
      <Routes history={app.history} />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/containers/App/index.jsx